import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";

import {EnvironmentService} from "./environment.service";
import { AppConfigService } from '../configuration/app.config.service';

export const URL_ENVIRONNEMENT_PREFIX = ['dev', 'int', 'qua', 'rec', 'eva', 'ppr'];

@Injectable({providedIn: 'root'})
export class UrlUtilsService {

    private MASK_ENV_PREFIX: string = '{{env}}';
    private MASK_FORMATION: string = '{{formation}}';
    private MASK_PORT: string = '{{port}}';

    constructor(private environmentService: EnvironmentService,
                private appConfigService: AppConfigService) {
    }

    getSigmanBaseUrl(): string {
        let sigmanBaseUrl: string = this.appConfigService.getUrls().baseUrl;

        if (environment.production) {
            sigmanBaseUrl = this.replacePrefixe(sigmanBaseUrl);
            sigmanBaseUrl = this.replaceEnvironnement(sigmanBaseUrl);
            sigmanBaseUrl = this.replacePort(sigmanBaseUrl);
        }

        return sigmanBaseUrl;
    }

    private replacePrefixe(baseUrl: string): string {
        let envPrefix: string = '';

        let currentHostName: string = this.environmentService.getCurrentHostName();
        let urlPrefix: string = currentHostName.substring(0, currentHostName.indexOf('-'));

        if (URL_ENVIRONNEMENT_PREFIX.indexOf(urlPrefix) !== -1) {
            console.log("Préfixe URL détécté:", urlPrefix);
            envPrefix = urlPrefix + '-';
        }
        return baseUrl.replace(this.MASK_ENV_PREFIX, envPrefix);
    }

    private replaceEnvironnement(baseUrl: string): string {
        let formation: string = '';

        if (this.environmentService.isFormationEnv()) {
            console.log("Environnement de FORMATION détecté");
            formation = '-' + this.environmentService.currentEnvironnement.toLowerCase();
        }
        return baseUrl.replace(this.MASK_FORMATION, formation);
    };

    private replacePort(baseUrl: string): string {
        let port: string = '';
        let currentPort: string = this.environmentService.getCurrentPort();
        if (!!currentPort) {
            port = ':' + currentPort;
        }

        return baseUrl.replace(this.MASK_PORT, port);
    }

}
